import PropTypes from "prop-types";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { confirmable, createConfirmation } from "react-confirm";
import { useTranslation } from "react-i18next";

const Confirmation = ({
  show,
  proceed,
  dismiss,
  cancel,
  confirmation,
  title,
  okText,
  cancelText,
  okButtonStyle,
  cancelButtonStyle,
  ...options
}: {
  show: any;
  proceed: any;
  dismiss: any;
  cancel: any;
  confirmation: any;
  title: any;
  okText: any;
  cancelText: any;
  okButtonStyle: any;
  cancelButtonStyle: any;
}) => {
  const { t } = useTranslation();
  return (
    <>
      {show && (
        <Modal
          show={show}
          onHide={() => proceed(false)}
          backdrop="static"
          centered
        >
          <Modal.Header closeButton className="tw-border-0 tw-items-start">
            <span className="tw-text-zinc-900 tw-text-xl tw-font-bold tw-font-['Sofia Sans'] tw-items-start tw-justify-between">
              {" "}
              {title ? title : confirmation}
            </span>
          </Modal.Header>
          {title & confirmation ? (
            <Modal.Body className="fs-5">{confirmation}</Modal.Body>
          ) : null}
          <Modal.Footer>
            <Button variant={cancelButtonStyle} onClick={() => proceed(false)}>
              {t(cancelText)}
            </Button>
            <Button variant={okButtonStyle} onClick={() => proceed(true)}>
              {t(okText)}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

Confirmation.propTypes = {
  /** header title */
  title: PropTypes.string,
  confirmation: PropTypes.string, // arguments of your confirm function
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  okButtonStyle: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
    "link"
  ]),
  cancelButtonStyle: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
    "link"
  ]),
  show: PropTypes.bool, // from confirmable.
  proceed: PropTypes.func, // from confirmable.
  cancel: PropTypes.func, // from confirmable.
  dismiss: PropTypes.func // from confirmable.
};

Confirmation.defaultProps = {
  title: undefined,
  confirmation: undefined,
  okText: "GlobalConfirmationModal/confirm",
  cancelText: "GlobalConfirmationModal/cancel",
  okButtonStyle: "secondary",
  cancelButtonStyle: "primary",
  show: undefined,
  proceed: undefined,
  cancel: undefined,
  dismiss: undefined
};

const confirmLow = createConfirmation(confirmable(Confirmation));

export const confirm = (message: string, options = {}) => {
  return confirmLow(Object.assign({ confirmation: message }, options));
};

const Alert = ({
  show,
  proceed,
  dismiss,
  cancel,
  confirmation,
  title,
  okText,
  okButtonStyle,
  ...options
}: {
  show: any;
  proceed: any;
  dismiss: any;
  cancel: any;
  confirmation: any;
  title: any;
  okText: any;
  okButtonStyle: any;
}) => {
  const header = title ? (
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
  ) : undefined;
  return (
    <>
      {show && (
        <Modal
          size="sm"
          show={show}
          onHide={() => proceed()}
          keyboard={true}
          backdrop="static"
          centered
        >
          {header}
          <Modal.Body>{confirmation}</Modal.Body>
          <Modal.Footer>
            <Button variant={okButtonStyle} onClick={() => proceed()}>
              {t(okText)}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

Alert.propTypes = {
  /** header title */
  title: PropTypes.string,
  confirmation: PropTypes.string, // arguments of your confirm function
  okText: PropTypes.string,
  okButtonStyle: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
    "link"
  ]),
  show: PropTypes.bool, // from confirmable.
  proceed: PropTypes.func, // from confirmable.
  cancel: PropTypes.func, // from confirmable.
  dismiss: PropTypes.func // from confirmable.
};

Alert.defaultProps = {
  title: undefined,
  confirmation: undefined,
  okText: "OK",
  okButtonStyle: "primary",
  show: undefined,
  proceed: undefined,
  cancel: undefined,
  dismiss: undefined
};

const alertLow = createConfirmation(confirmable(Alert));

export const alert = (message: string, options = {}) => {
  return alertLow(Object.assign({ confirmation: message }, options));
};
